import { defineMessages } from 'react-intl';

export default defineMessages({
  TITLE: { defaultMessage: "Voulez-vous vraiment supprimer l'énoncé ?" },
} as const);
